import React, { Component } from "react";
import GetArticles from "./get-articles.component";
import "./margin-right.component.scss";

/**
 * Post index. Sticks alongside the reading column on wide viewports and falls
 * beneath it on narrow ones — no fixed positioning, so it can no longer run
 * off the edge of the screen.
 */
class MarginRightComponent extends Component {
  render() {
    return (
      <aside id="posts" className="margin-right-container">
        <h2 className="index-heading">Posts</h2>
        <GetArticles></GetArticles>
      </aside>
    );
  }
}

export default MarginRightComponent;
